$.fn.CartButton = function() {
  let self = this
  self.quantity = undefined

  /* Simplified add to cart */
  self.add_to_cart = function(e) {
    e.preventDefault()

    // Validation for variable products with variations
    if (self.hasClass('product_type_variable')) {
      const $card = self.closest('.card-wishlist, .reels-panel__card')
      const $variations = $card.find('.card-wishlist__variations, .reels-panel__variations')

      if ($variations.length) {
        const $selects = $variations.find('select')
        let allSelected = true

        $selects.each(function() {
          if (!$(this).val() || $(this).val() === '') {
            allSelected = false
          }
        })

        if (!allSelected) {
          // Show validation modal
          if ($.mlmi && $.mlmi.favorites && $.mlmi.favorites.showModal) {
            $.mlmi.favorites.showModal({
              title: gourmetsauvage_params.WISHLIST_VARIATION_REQUIRED_TITLE,
              content: '<p>' + gourmetsauvage_params.WISHLIST_VARIATION_REQUIRED_MESSAGE + '</p>',
              ctaText: gourmetsauvage_params.WISHLIST_VARIATION_REQUIRED_OK,
              onCta: (closeModal) => {
                closeModal()
              }
            })
          }
          return false
        }
      }
    }

    self.removeClass('added').addClass('loading')

    /* Prepare data to cart */
    let add_item_data = {
      'quantity': self.quantity != undefined && parseInt(self.quantity.val(), 10) ? parseInt(self.quantity.val(), 10) : parseInt(self.data('quantity'), 10),
      'product_id': self.data('product_id'),
      'variation_id': self.data('variation-id') || self.data('variation_id') || 0,
    }

    /* Produit gratuit des récompenses panier : le serveur valide le palier et force le prix à 0 */
    if (self.data('gs_reward')) {
      add_item_data.gs_reward = self.data('gs_reward')
    }

    /* Meta CAPI event_id for deduplication. JS = source de vérité, posé avant le POST
       pour que le pixel browser et le CAPI server partagent le même event_id. */
    var meta_event_id = 'addtocart_' + add_item_data.product_id + '_' + Math.floor(Date.now()/1000)
    window.__meta_addtocart_event_id = meta_event_id
    add_item_data.meta_event_id = meta_event_id

    /* Collect bundle optional selections from wishlist cards and reels panel cards */
    const $card = self.closest('.card-wishlist, .reels-panel__card')
    if ($card.length) {
      const $bundleData = $card.find('.card-wishlist__bundle-data, .reels-panel__bundle-data')
      if ($bundleData.length) {
        $bundleData.find('input[name^="bundle_selected_optional_"]').each(function() {
          if ($(this).prop('checked')) {
            add_item_data[$(this).attr('name')] = 1
          }
        })
      }
    }

    /* Post to cart */
    const isHotspot = self.closest('.hotspot').length
    const originalHtml = self.html()
    if (!isHotspot) {
      self.html(gourmetsauvage_params.ADDING_TO_CART)
    }
    $.ajax({
      url: window.wc_cart_fragments_params.wc_ajax_url.replace('%%endpoint%%', 'add_to_cart'),
      type: 'POST',
      data: add_item_data,
      success: function(x) {
        /* Verrou pré-vente crémant : erreur serveur portant une charge modale → pop-up Wishlist */
        if (x && x.success === false && x.data && x.data.modal) {
          self.removeClass('loading')
          if (!isHotspot) {
            self.html(originalHtml)
          }
          if ($.mlmi && $.mlmi.favorites && $.mlmi.favorites.showModal) {
            $.mlmi.favorites.showModal({
              title: x.data.modal.title,
              content: x.data.modal.message,
              ctaText: gourmetsauvage_params.WISHLIST_OK,
              onCta: (closeModal) => {
                closeModal()
              }
            })
          }
          return
        }
        self.removeClass('loading').addClass('added')
        if (!isHotspot) {
          self.html(gourmetsauvage_params.ADDED_TO_CART)
        }
        $.mlmi.cart.refreshFragments(x)
      },
    })
  }

  return function() {
    // Check for quantity input in product list or wishlist context
    const $container = self.closest('.product-list__add-to-cart, .card-wishlist__add-to-cart')
    if ($container.length && $container.find('input.qty').length) {
      self.quantity = $container.find('input.qty').Quantity()
    }
    self.off('click', self.add_to_cart).on('click', self.add_to_cart)
    return self
  }()
}
